import { render, staticRenderFns } from "./UpgradesTable.vue?vue&type=template&id=5d902962&scoped=true&"
import script from "./UpgradesTable.vue?vue&type=script&lang=js&"
export * from "./UpgradesTable.vue?vue&type=script&lang=js&"
import style0 from "./UpgradesTable.vue?vue&type=style&index=0&id=5d902962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d902962",
  null
  
)

export default component.exports